export default { version: '0.4.7', commit: 'fef5073d3031af2ef74db867f027e578c1a56faa', date: '1677232949' }
